// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nvwc-dialog[data-v-578cad0e] {\n  --mdc-dialog-min-width: 390px;\n  --mdc-dialog-max-width: 500px;\n  --mdc-dialog-z-index: 100000;\n}\n.dialog-icon[data-v-578cad0e] {\n  color: var(--vvd-color-on-canvas);\n  margin-bottom: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
